export default class {

    constructor ($translate, toastr, ModalService) {
        this.toastr = toastr;
        this.$translate = $translate;
        this.ModalService = ModalService;
    }

    delete (role) {
        return this.ModalService.delete()
            .then(() => role.$delete({ id: role.id }))
            .then(() => this.toastr.success(this.$translate.instant('role.Role deleted')));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/role/index.js